import Modal from 'src/components/Modal'
import Button from '../../../../components/Button'
import * as S from './PauseFractioning.styles'
import { handleOnKeyDown } from 'src/utils/Form'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { actions } from '../../FractionState'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

interface PauseFractioningProps {
  idBatch: number
  onPause: () => void
}

const PauseFractioning = ({
  idBatch,
  onPause,
}: PauseFractioningProps) => {
  const {
    register, setError, watch, resetField, clearErrors, formState: { errors },
  } = useForm<{ badge: string }>()

  const dispatch = useDispatch()

  const [show, setShow] = useState(false)
  const [inputBadgeFocused, setInputBadgeFocused] = useState(false)
  const [preventDoubleSubmit, setPreventDoubleSubmit] = useState(false)
  const badge = watch('badge')

  const pauseFracioning = async () => {
    if (preventDoubleSubmit) return

    setPreventDoubleSubmit(true)

    clearErrors()

    if (!badge) {
      setError('badge', { message: 'Campo obrigatório' })
      setPreventDoubleSubmit(false)
      return
    }

    const onSuccess = () => {
      resetField('badge')
      setShow(false)
      setPreventDoubleSubmit(false)
      toast.success('Fracionamento pausado com sucesso!')
      onPause()
    }

    const onError = (message: string) => {
      setError('badge', { message })
      setPreventDoubleSubmit(false)
    }

    dispatch(actions.pauseFractioning({
      idBatch, badge, onSuccess, onError,
    }))
  }

  const handleClose = () => {
    setShow(false)
    resetField('badge')
    clearErrors()
  }

  return (
    <>
      <Button
        type='button'
        text='Pausa'
        onClick={() => setShow(true)}
        testId='pause-button-test-id'
      />
      <Modal
        show={show}
        testId='badge-modal-test-id'
        centered
        title='Confirme a pausa do lote'
        closeButtonAction={handleClose}
        closedButton
        body={(
          <S.ModalContainer>
            <S.ModalCustomTextField
              sx={{
                '& .MuiInputLabel-outlined': {
                  transform: 'translate(14px, 13px) scale(1) !important',
                },
                '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                  transform: 'translate(14px, -9px) scale(0.75) !important',
                },
              }}
              inputProps={{
                ...register('badge'),
                'data-testid': 'badge-input-test-id',
              }}
              testId='badge-input-test-id'
              id='badge'
              name='badge'
              type='password'
              autoComplete='new-password'
              onCut={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              error={!!errors.badge}
              label='badge'
              helperText={!!errors.badge && errors.badge.message}
              fullWidth
              size='medium'
              autoFocus
              InputLabelProps={{ shrink: inputBadgeFocused || !!badge }}
              onFocus={() => setInputBadgeFocused(true)}
              onBlur={() => setInputBadgeFocused(false)}
              onKeyDown={(e) => handleOnKeyDown(e, '', pauseFracioning)}
            />
          </S.ModalContainer>
        )}
      />
    </>
  )
}

export { PauseFractioning }
